import BTBulkManagement from "@extension/context/content/components/bt-bulk-dashboard/bt-bulk-management"
import { Box } from "@mui/material"
import { setActiveBulkView, resetCampaignAndTemplateThunk } from "@common-reducers/CampaignReducer"
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook"
import { useEffect } from "react"
import BTBulkDashboard from "@extension/context/content/components/bt-bulk-dashboard/bt-bulk-dashboard"
import BulkLogsView from "@extension/context/content/components/bt-bulk-dashboard/bulk-logs-view/bulk-logs-view"
import BulkTaskViewContainer from "@extension/context/content/components/bt-bulk-dashboard/bulk-task-view-container"
import NewTemplateView from "@extension/context/content/components/bt-bulk-dashboard/new-template-view"

interface CampaignManagementViewProps {
    /** Forwarded to BTBulkManagement to suppress its in-component tab bar when
     *  an outer surface (the campaigns redesign) provides its own tabs and
     *  drives `activeTab`. Defaults to false for existing callers. */
    hideTabs?: boolean;
}

export const CampaignManagementView = ({ hideTabs = false }: CampaignManagementViewProps = {}) => {
    const dispatch = useAppDispatch()
    const activeBulkView = useAppSelector((state) => state.CampaignReducer.activeBulkView);

    useEffect(() => {
        dispatch(setActiveBulkView('campaignManagementView'))
    }, [])

    // Reset campaign and template state when starting a new campaign
    useEffect(() => {
        if (activeBulkView === 'newCampaignView') {
            dispatch(resetCampaignAndTemplateThunk());
        }
    }, [activeBulkView, dispatch])

    return <Box>
        {
            activeBulkView === "campaignManagementView" &&
            <BTBulkManagement hideTabs={hideTabs} />
        }

        {
            (activeBulkView === "campaignLogsView") &&
            <BulkLogsView/>
        }
        {
            (activeBulkView === "newCampaignView" ||
             activeBulkView === "campaignNewAudienceFromManagementView" ||
             activeBulkView === "campaignNewAudienceFromNewCampaignView"
            ) &&
            <BTBulkDashboard />
        }
        {/* A row-click in the management list opens the audience BOARD editor
            (its contacts/tasks), NOT the launch stepper. `BTBulkDashboard` is the
            launch flow ("Audience → Message → Timing → Launch") — routing the
            board sub-view to it was the bug where clicking an audience opened the
            campaign launch flow. The canonical container (`CampaignsView`, used by
            every other campaign route) maps these sub-views to the real board /
            template editors; mirror that here so this management container behaves
            identically and the redesign's Audiences/Templates tabs never surface
            the launch stepper. */}
        {
            (activeBulkView === "campaignBoardFromManagementView" ||
             activeBulkView === "campaignBoardFromNewCampaignView"
            ) &&
            <BulkTaskViewContainer />
        }
        {
            (activeBulkView === "campaignNewTemplateViewFromManagement" ||
             activeBulkView === "campaignNewTemplateViewFromNewCampaignView" ||
             activeBulkView === "campaignNewTemplateViewFromWhatsappView"
            ) &&
            <NewTemplateView />
        }
    </Box>
}